import { Rect } from '../../classes/rect.class';
import { GetBounds } from '../../lib/get-bounds';
import { AssetPageData } from '../types/asset-page-data';
import { Shape } from '../types/shapes';
import { getLeftMostPoint, getRightMostPoint } from './get-annotation-bounds';

export const relativeToAbsolutePosition = (
  point: Rect,
  active: AssetPageData,
  sideMenuOpen: boolean,
  isDesktop: boolean
) => {
  const { offsetScale, scale, asset, offset, _offsetY } = active;
  const bounds = GetBounds(offsetScale, scale, sideMenuOpen, asset, offset.x, _offsetY, isDesktop);
  return new Rect(bounds.x + bounds.width * point.x, bounds.y + bounds.height * point.y);
};

export const getShapeCommentPosition = (
  shapes: (Shape | Rect)[],
  active: AssetPageData,
  sideMenuOpen: boolean,
  isDesktop: boolean,
  containerWidth: number,
  commentBoxWidth: number
) => {
  const pos = (() => {
    const rightMostPoint = relativeToAbsolutePosition(getRightMostPoint(shapes), active, sideMenuOpen, isDesktop);
    if (rightMostPoint.x + commentBoxWidth < containerWidth) return rightMostPoint;
    const leftMostPoint = relativeToAbsolutePosition(getLeftMostPoint(shapes), active, sideMenuOpen, isDesktop);
    if (leftMostPoint.x - commentBoxWidth > 0) return new Rect(leftMostPoint.x - commentBoxWidth, leftMostPoint.y);

    return relativeToAbsolutePosition(new Rect(0.5, 0.5), active, sideMenuOpen, isDesktop).subtract(
      new Rect(commentBoxWidth / 2, 0)
    );
  })();

  if (pos.y + 174 > window.innerHeight) {
    pos.y = window.innerHeight - 174;
  }

  return pos;
};

export const getPointCommentPosition = (
  point: Rect,
  containerWidth: number,
  commentBoxWidth: number
): { pos: Rect; align: 'left' | 'right' | 'center' } => {
  const { pos, align } = (() => {
    const rightMostPoint = point.x + point.width;
    if (rightMostPoint + commentBoxWidth < containerWidth) {
      return { pos: new Rect(rightMostPoint, point.y + point.height / 2), align: 'right' };
    }
    const leftMostPoint = point.x;
    if (leftMostPoint - commentBoxWidth > 0) {
      return { pos: new Rect(leftMostPoint - commentBoxWidth, point.y + point.height / 2), align: 'left' };
    }
    return {
      pos: new Rect(containerWidth / 2, point.y + point.height / 2, point.width, point.height).subtract(
        new Rect(commentBoxWidth / 2, 0)
      ),
      align: 'center',
    };
  })();

  if (pos.y + 174 > window.innerHeight) {
    pos.y = window.innerHeight - 174;
  }

  return { pos, align: align as 'left' };
};
